import React from 'react';
import Svg, {Path} from 'react-native-svg';
import {Props} from '../../../shared/assets/SvgProps';

/**
 * PieChartArrowUp — vertically-flipped version of PieChartArrow.
 * The SVG transform "translate(0,11) scale(1,-1)" maps every y → (11 − y),
 * turning the down-pointing tip into an up-pointing tip within the same viewBox.
 */
const PieChartArrowUp = ({color = 'white'}: Props) => (
  <Svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none">
    <Path
      transform="translate(0, 11) scale(1, -1)"
      d="M6.16824 9.4075L-0.000379315 0.000217905L15.6819 0.000218411L9.51324 9.4075C8.72348 10.6119 6.958 10.6119 6.16824 9.4075Z"
      fill={color}
    />
  </Svg>
);

export default PieChartArrowUp;